import { environment }  from '@env/environment';

export const APP_CONSTANTS = {
  /** Checkout → My Account register: billing draft in sessionStorage */
  STOREFRONT_CHECKOUT_REGISTER_DRAFT_KEY: 'storefrontCheckoutRegisterDraft',
  /** Domain -> selected storefront private_web_address mapping */
  STOREFRONT_DOMAIN_STORE_SELECTION_KEY: 'storefrontDomainStoreSelection',
  /**
   * Store list for a domain when `is_multiple_location` is true (separate from `auth/store` object).
   * Example: GET auth/stores_by_domain?domain_name=...
   * Set to your real path; if empty, code falls back to auth/store + STORE_LIST_FOR_DOMAIN_QUERY_PARAM.
   */
  AUTH_STORE_LIST_BY_DOMAIN: 'auth/stores_by_domain',
  /**
   * Legacy fallback only: GET auth/store?domain_name=...&<this>=true
   */
  STORE_LIST_FOR_DOMAIN_QUERY_PARAM: 'store_list_for_domain',
  APP_TITLE: environment.appTitle,
  BASE_URL: environment.baseUrl,
  SERVER_URL: environment.serverUrl,
  API_URL: environment.apiUrl,
  DOWNLOAD_URL: environment.downloadUrl,
  IS_PRODUCT: environment.production,
  IS_FRONT: environment.staging,
  PAYPAL: {
    CLIENT_ID: environment.paypal.clientId,
    SECRET: environment.paypal.secret
  },
  GOOGLE: {
    CLIENT_ID: environment.google.clientId
  },
  PLANS: {
    FREE: environment.plans.free,
    STARTER: environment.plans.starter,
    ADVANCED: environment.plans.advanced,
    MULTI_OUTLET: environment.plans.multi_outlet
  }
};

export const Constants = {
  message: {
    validEmail: 'Please enter valid email address',
    invalidMinLength: 'This field must be longer than ? letters',
    invalidMaxLength: 'This field must be less than ? letters',
    duplicatedEmail: 'This email is already in use',
    requiredField: 'This field is required',
    invalidMinValue: 'This value must be greater than ?',
    invalidMaxValue: 'This value must be less than ?',
    successLogin: 'You logged in successfully',
    successSwitch: 'User has been switched successfully',
    notVerifiedEmail: 'Please verify your email',
    noExistingUser: 'No Existing User',
    noExistingCustomer: 'No Existing Customer',
    noExistingEmployee: 'No Existing Employee',
    successSaved: 'Successfully saved',
    successRemoved: 'Successfully removed',
    successVoided: 'Successfully voided',
    failedSave: 'Failed to save',
    failedRemove: 'Failed to remove',
    invalidFields: 'Please enter fields correctly',
    duplicateItem: 'Already existing ?',
    product_contains: 'Can not remove this attribute because some products contain this one.',
    successUpload: 'Successfully uploaded',
    failedUpload: 'Failed to upload',
    noExistingProduct: 'No Existing Product',
    validPassword: 'Valid Password. You can add discount',
    notAllowedDiscount: 'You have no permission to apply discount',
    invalidCartProducts: 'Please add at least one product',
    successAddedToCart: 'Successfully added to cart',
    successComplete: 'Successfully completed',
    successOpenRegister: 'Resiter opened successfully.',
    sale: {
      completed: 'Sale has been completed successfully',
      parked: 'Sale has been parked successfully',
      discard: 'Sale has been discarded successfully',
      quote: 'Sale has been quoted successfully',
      delivery_unfulfilled: 'Sale has been marked as unfulfilled for delivery',
      pickup_unfulfilled: 'Sale has been marked as unfulfilled for pickup',
      layby: 'Sale has been saved as Layby',
      on_account: 'Sale has been saved as On Account',
      quoted: 'Sale has been quoted successfully'
    },
    sale_note: {
      park: 'You are about to park this sale. Add a note so it can be identified by the next person who continues this sale.',
      quote: 'You are about to quote this sale. Add a note so it can be identified by the person who completes this sale.'      
    }
  },  
  completed_status: ['layby_completed', 'completed', 'on_account_completed', 'delivery_completed', 'pickup_completed'],
  continue_status: ['layby', 'parked', 'on_account'],
  unfulfilled_status: ['delivery_unfulfilled', 'pickup_unfulfilled'],
  paid_status: ['on_account', 'completed', 'layby_completed', 'on_account_completed', 'delivery_completed', 'pickup_completed', 'return_completed'],
  password:{minLength: 1, maxLength: 20},
  open_value:{min: 1},
  securities : [
    {id: 0, name: 'Never require a password when switching between users.'},
    {id: 1, name: 'Require a password when switching to a user with greater privileges.'},
    {id: 2, name: 'Always require a password when switching between users'}
  ],
  cash_transaction : {min: 1},
  discount: {min: 1},  
  sale_status : [
    {value: 'new', label: 'New Sale'},
    {value: 'layby', label: 'LayBy'},
    {value: 'on_account', label: 'On Account'},
    {value: 'parked', label: 'Parked'},
    {value: 'delivery_unfulfilled', label: 'Delivery,unfulfilled'},
    {value: 'pickup_unfulfilled', label: 'Pickup,unfulfilled'},
    {value: 'completed', label: 'Completed'},
    {value: 'layby_completed', label: 'LayBy,completed'},
    {value: 'on_account_completed', label: 'On Account,completed'},
    {value: 'delivery_completed', label: 'Delivery,completed'},
    {value: 'pickup_completed', label: 'Pickup,completed'},
    {value: 'return_completed', label: 'Return,completed'},
    {value: 'voided', label: 'Voided'}
  ],
  order_status : [
    {code: 'awaiting', label:'Awaiting Payment'}, 
    {code: 'allocated', label: 'Allocated'}, 
    {code: 'shipped', label: 'Shipped'}, 
    {code: 'quote', label: 'Quote'}
  ],
  payment_status : [
    {code: 'not_paid', label: 'Not Paid'}, 
    {code: 'full_paid', label: 'Fully Paid'}, 
    {code: 'partial_paid', label: 'Partially Paid'}
  ],
  plans: [
    // {
    //   id: 'free',
    //   label: 'Basic',
    //   price: 0,
    //   features: [
    //     ['Single Outlet', '1 Register only'],
    //     ['1 User only', 'upto 10 products only', 'upto 1000 customers only'],
    //     ['Community support']
    //   ]
    // },
    {
      id: 'starter',
      label: 'Starter',
      price: 69,
      features: [
        ['Single Outlet', '1 Register only'],
        ['up to 3 users only', 'Unlimited products & customers'],
        ['Loyalty', 'Advance reporting'],
        ['Email & Chat Support']
      ]
    },
    {
      id: 'advanced',
      label: 'Advanced',
      price: 89,
      features: [
        ['Start with 1 register (add more as you grow)'],
        ['up to 3 users', 'Unlimited products, customers'],
        ['Gift cards', 'Loyalty', 'Ecommerece', 'Advance Reporting', 'Advanced User Permissions'],
        ['Email & Chat Support']
      ]
    },
    // {
    //   id: 'multi_outlet',
    //   label: 'Multi Outlet',
    //   price: 199,
    //   features: [
    //     ['Single Outlet', 'Start with 2 registers (add more as you grow)'],
    //     ['Unlimited products, users & customers'],
    //     ['Multi-outlet inventory', 'Central customer database', 'HQ and outlet reporting', 'Timezone support', 'Consolidated billing and admin'],
    //     ['Priority Phone Support']
    //   ]
    // }
  ],
  dashboardItems: [
    {
      label: 'Ecommerce',
      imageIcon: '/assets/image/icon/ecommerce.png',
      items: [
        {
          label: 'Dashboard',
          link: 'ecommerce/dashboard',
        },
        {
          label: 'Collections',
          link: 'ecommerce/collections',
        },
        {
          label: 'Products',
          link: 'ecommerce/product',
        },
        {
          label: 'Orders',
          link: 'ecommerce/orders',
        },
        {
          label: 'Settings',
          link: 'ecommerce/settings',
        },
        {
          label: 'Pages',
          link: 'ecommerce/pages',
        },
        {
          label: 'Visit Online Store',
          link: '/restaurant/',
          externalRedirect: true,
          hrefTargetType: '_blank'
        },
      ]
    },
  ],
  dashboardConfig: {
    paddingAtStart: true,
    classname: 'capos-side-menu',
    collapseOnSelect: true,
    useDividers: false
  },
  baseUrl: {
    dev: '',
    prod: ''
  }

};

export const StoreConstants = {
  theme_color: '00c0f0',
  currencies: ['USD', 'EUR'],
  flags: [
      { name:'English', image: 'assets/images/flags/gb.svg' },
      { name:'German', image: 'assets/images/flags/de.svg' },
      { name:'French', image: 'assets/images/flags/fr.svg' },
      { name:'Russian', image: 'assets/images/flags/ru.svg' },
      { name:'Turkish', image: 'assets/images/flags/tr.svg' }
  ],
  default_sliders: [
    {
      title: 'Huge sale', 
      subtitle:'Up to 70%', 
      button: 'Shop Now', 
      href:'',
      image: ''
    },
    {
      title: 'Biggest discount', 
      subtitle:'Check the promotion', 
      button: 'Shop Now', 
      href:'',
      image: ''
    },
    {
      title: 'Biggest sale', 
      subtitle:'Dont miss it', 
      button: 'Shop Now', 
      href:'',
      image: ''
    },
    {
      title: 'Our best products', 
      subtitle:'Special selection', 
      button: 'Shop Now', 
      href:'',
      image: ''
    },
    {
      title: 'Massive sale', 
      subtitle:'Only for today', 
      button: 'Shop Now', 
      href:'',
      image: ''
    }
  ],
  default_banner_images: [
    'assets/images/product/laptop.png', 'assets/images/product/tablet.png', 'assets/images/product/cameras.png', 'assets/images/product/mobiles.png'
  ],  
  default_banners: [
    {
      title: 'NEW LAPTOPS', 
      subtitle:'Sale up to 30% off all products in the new collection.', 
      button: 'Shop Now', 
      href:'',
      image: ''
    },
    {
      title: 'TABLETS, SMARTPHONES AND MORE', 
      subtitle:'Sale up to 30%.', 
      button: 'Shop Now', 
      href:'',
      image: ''
    },
    {
      title: 'NEW CAMERAS COLLECTION', 
      subtitle:'Sale up to 30%.', 
      button: 'Shop Now', 
      href:'',
      image: ''
    },
    {
      title: 'CACH BIG OFFERS ON CAMERAS', 
      subtitle:'Sale up to 20%.', 
      button: '$66.00', 
      href:'',
      image: ''
    }
  ],
  default_services: [
    {
      name: 'BONUS PLUS',
      description: 'Get a bonus plus for buying more that three products',
      icon: 'card_giftcard'
    },
    {
      name: 'FREE SHIPPING',
      description: 'Free shipping on all orders over $99',
      icon: 'local_shipping'
    },
    {
      name: 'MONEY BACK GUARANTEE',
      description: '100% money back guarantee',
      icon: 'monetization_on'
    },
    {
      name: 'ONLINE SUPPORT 24/7',
      description: 'Call us: 02 3555 65454 55',
      icon: 'history'
    }
  ],
  navItems: [
    {
      displayName: 'Home',
      iconName: 'recent_actors',
      route: '/home'
    },
    // {
    //   displayName: 'Categories',
    //   iconName: 'feedback',
    //   children: [
    //     {
    //       displayName: 'All Categories',
    //       iconName: 'group',
    //       route: '/products/all'
    //     }
    //   ]
    // },
    {
      displayName: 'Menu',
      iconName: 'report_problem',
      route: '/menu'
    },
    {
      displayName: 'Catering',
      iconName: 'restaurant',
      route: '/catering'
    },
    {
      displayName: 'Blog',
      iconName: 'report_problem',
      route: '/blog'
    },
    {
      displayName: 'Review',
      iconName: 'speaker_notes',
      route: '/review'
    },
    {
      displayName: 'About Us',
      iconName: 'group',
      route: '/about'
    },
    {
      displayName: 'Contact',
      iconName: 'feedback',
      route: '/contact'
    } 
  ],    
}
